<template>
  <div>
    <van-nav-bar
      title="数电发票"
      left-arrow
      @click-left="back"
      style="font-size: 12px;color: #333333;"
    />

    <div v-for="(item,index) in allData" :key="index" class="reserve_main" @click="toOrderDetail(item)" v-show="allData.length">
      <van-button type="info" block @click="toOrderDetail(item)">
        {{ item.billName }}
      </van-button>
    </div>
    <div v-if="!allData.length" class="reserve_null">
      没有更多数据了~
    </div>
  </div>
</template>
<script>
import {Cell, Field, Popup, Picker, NavBar, Button, Switch, Icon,DropdownItem} from 'vant'
import {mapGetters} from 'vuex'
import { getRelativeDate,getLongStrDate } from 'Utils/dateUtil'
export default {
  name: 'billInvoice',
  components:{
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [NavBar.name]:NavBar,
    [Button.name]:Button,
    [Switch.name]:Switch,
    [Icon.name]:Icon,
    [DropdownItem.name]: DropdownItem,
  },
  data (){
    return {
      allData:'',
      params: {
        dateType: '1',
        drawDateStart: getRelativeDate(-90) + ' 00:00:00',
        drawDateEnd: getLongStrDate(),
      }
    }
  },
  created(){
    this.search()
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    }),
  },
  methods:{
    back(){
      this.$router.push({path:'/userCenter'})
    },
    search(){
      this.filterShow = true
      this.allData = [{
        billType:'-1',
        billName: '其他发票'
      },{
        billType:'1',
        billName: '火车票发票'
      }]
    },
    // 跳转订单详情
    toOrderDetail(item) {
      if (item.billType == '1') {
        this.$router.push('/userCenter/billInvoice/trainsInvoice')
      }else {
        this.$toast.success('敬请期待！');
      }
    },
  },
}
</script>
<style lang="less" scoped>
.reserve_main{
    background-color: #fff;
    margin: 5px;
    padding: 5px 10px;
    line-height: 25px;
    .reserve_main_title{
        font-weight: 600;
    }
}
.reserve_null{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #969799;
    width: 100%;
    height: 100px;
}
</style>
